import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import dayjs from "dayjs";
import { Toast } from "react-bootstrap";
import { Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faTrophy,
  faComments,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type Permission = { id: number; name: string };

type Admin = {
  student_id: number;
  gender_name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  section_name: string;
  agent_name: string;
  academic_year_name: string;
  varna_student_id: string | null;
  SCS_Number: string;
  is_active: boolean;
  academic_year: number;
  gender: number;
  admission_status: number;
  state: number;
  zone: number;
  branch: number;
  orientation: number;
  student_class: number;
  section: number;
  agent: number;
  name: string;
  no_of_attempts: number;
};

// type Disposition = {
//   studentdisposition_id: number;
//   disposition_name: string;
// };

// type TicketType = {
//   ticket_type_id: number;
//   ticket_type: string;
// };

type Category = {
  category_id: number;
  category_name: string;
};

type SubCategory = {
  subcategory_id: number;
  subcategory_name: string;
};

type Priority = {
  priority_id: number;
  priority_name: string;
};

interface Ticket {
  category?: number | null;
  subcategory?: number | null;
  priority?: number | null;
  description?: string;
  callbacktime?: string | null;
}

interface ScriptData {
  script_id: number;
  script_name: string;
  script_file: string;
  is_active: boolean;
}

interface ScriptDropdown {
  script_id: number;
  script_name: string;
}

const AddSummerCampCallBackTicket = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [callLoading, setCallLoading] = useState(false);
  const [data, setData] = useState<Admin[]>([]);
  const [ticketData, setTicketData] = useState({});
  // const [dispositionData, setDispositionData] = useState<Disposition[]>([]);
  const [categoriesData, setCategoriesData] = useState<Category[]>([]);
  const [subCategoryData, setSubCategoryData] = useState<SubCategory[]>([]);
  const [priorityData, setPriorityData] = useState<Priority[]>([]);
  // const [typeOfTicketData, setTypeOfTicketData] = useState<TicketType[]>([]);
  const [showCallBackTime, setShowCallBackTime] = useState(false);
  const [isCalling, setIsCalling] = useState(false);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showCard, setShowCard] = useState(false);
  const [pdfSrc, setPdfSrc] = useState("");
  const [selectedScript, setSelectedScript] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [scriptDropdown, setScriptDropdown] = useState<ScriptDropdown[]>([]);
  // const [selectedDisposition, setSelectedDisposition] =
  //   useState<Disposition | null>(null);
  // const [selectedTypeOfTicket, setSelectedTypeOfTicket] =
  //   useState<TicketType | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<Option | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<Option | null>(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState<Option | null>(
    null
  );
  const [sdata, setsData] = useState<ScriptData[]>([]);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    student_id: 0,
    gender_name: "",
    admission_status_name: "",
    state_name: "",
    zone_name: "",
    branch_name: "",
    orientation_name: "",
    student_class_name: "",
    section_name: "",
    agent_name: "",
    academic_year_name: "",
    varna_student_id: null,
    SCS_Number: "",
    is_active: false,
    academic_year: 0,
    gender: 0,
    admission_status: 0,
    state: 0,
    zone: 0,
    branch: 0,
    orientation: 0,
    student_class: 0,
    section: 0,
    agent: 0,
    name: "",
    no_of_attempts: 0,
  });

  const [newTicket, setNewTicket] = useState<Ticket>({
    category: null,
    subcategory: null,
    priority: null,
    description: "",
    callbacktime: null,
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchProviderData = async (id: string) => {
    const response = await fetch(
      `${webApi}/students/summercamp_student/${id}`,
      options
    );
    return await response.json();
  };

  // const fetchTicketData = async (id: string) => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/summer_camp_tickets/${id}`,
  //     options
  //   );
  //   return await response.json();
  // };

  // const fetchDispositionData = async () => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/dispositions_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchCategoriesData = async () => {
    const response = await fetch(
      `${webApi}/summercamp/categories_dropdown/`,
      options
    );
    return await response.json();
  };

  const fetchSubCategoryData = async (categoryId: number) => {
    const response = await fetch(
      `${webApi}/summercamp/subcategories_by_category/${categoryId}/`,
      options
    );
    return await response.json();
  };

  const fetchPriorityData = async () => {
    const response = await fetch(
      `${webApi}/summercamp/priorities_dropdown/`,
      options
    );
    return await response.json();
  };

  const fetchDropdownData = async () => {
    try {
      const response = await fetch(
        `${webApi}/scripting/script_dropdown/`,
        options
      );
      const result = await response.json();
      if (Array.isArray(result)) {
        setScriptDropdown(result);
      }
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // const fetchTypeOfTicketData = async () => {
  //   const response = await fetch(
  //     `${webApi}/wizklub/type_of_tickets_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const handleCallClick = async () => {
    setCallLoading(true);
    try {
      const response = await fetch(
        `${webApi}/call/calling/?scsnumber=${newAdmin.SCS_Number}`,
        options
      );

      if (response.status === 200) {
        setIsCalling(true);
      } else {
        const errorMessage = await response.text();
        setToastMessage(errorMessage);
        setShowSolidDangerToast(true);
        setTimeout(() => {
          setShowSolidDangerToast(false);
        }, 3000);
        console.log(toastMessage);
      }
    } catch (error) {
      if (error instanceof Error) {
        setToastMessage(`Error calling API: ${error.message}`);
      } else {
        setToastMessage("Unknown error occurred while calling API");
      }
      setShowSolidDangerToast(true);
      setTimeout(() => {
        setShowSolidDangerToast(false);
      }, 3000);
    } finally {
      setCallLoading(false);
    }
  };

  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);

  const handleEndCallClick = () => {
    setIsCalling(false);
    // Handle call end logic
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (id) {
        const [providerData, priorityDataResponse, categoriesDataResponse] =
          await Promise.all([
            fetchProviderData(id),
            fetchPriorityData(),
            fetchCategoriesData(),
          ]);

        setData(providerData);
        // setTicketData(ticketDataResponse);
        // setDispositionData(dispositionDataResponse);
        setPriorityData(priorityDataResponse);
        setCategoriesData(categoriesDataResponse);
        // setTypeOfTicketData(typeOfTicketDataResponse);
        setNewAdmin({
          ...newAdmin,
          student_id: providerData.student_id,
          gender_name: providerData.gender_name,
          admission_status_name: providerData.admission_status_name,
          state_name: providerData.state_name,
          zone_name: providerData.zone_name,
          branch_name: providerData.branch_name,
          orientation_name: providerData.orientation_name,
          student_class_name: providerData.student_class_name,
          section_name: providerData.section_name,
          agent_name: providerData.agent_name,
          academic_year_name: providerData.academic_year_name,
          varna_student_id: providerData.varna_student_id,
          SCS_Number: providerData.SCS_Number,
          is_active: providerData.is_active,
          academic_year: providerData.academic_year,
          gender: providerData.gender,
          admission_status: providerData.admission_status,
          state: providerData.state,
          zone: providerData.zone,
          branch: providerData.branch,
          orientation: providerData.orientation,
          student_class: providerData.student_class,
          section: providerData.section,
          agent: providerData.agent,
          name: providerData.name,
          no_of_attempts: providerData.no_of_attempts,
        });
      } else {
        console.error("ID is undefined");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // if (!checkPermission("change", "Can change summer camp ticket")) {
    //   Cookies.remove("authToken");
    //   navigate("/login");
    // } else {
    fetchData();
    // }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTicket),
    };
    const url = `${webApi}/summercamp/ticket_operations/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();

      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading1(true);
    try {
      await updateData();
      navigate(routes.SummerCampCallBacks);
    } catch (error) {
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    if (name === "callbacktime") {
      const formattedValue = value
        ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
        : undefined;
      setNewTicket({ ...newTicket, [name]: formattedValue });
      // e.target.blur();
    } else {
      setNewTicket({ ...newTicket, [name]: value || undefined });
    }
  };

  // const dispositionOptions = dispositionData.map((d) => ({
  //   value: d.student_disposition_id.toString(),
  //   label: d.disposition_name,
  // }));

  // const ticketTypeOptions = typeOfTicketData.map((t) => ({
  //   value: t.ticket_type_id.toString(),
  //   label: t.ticket_type,
  // }));

  const categoryOptions = categoriesData.map((c) => ({
    value: c.category_id.toString(),
    label: c.category_name,
  }));

  const subCategoryOptions = subCategoryData.map((sc) => ({
    value: sc.subcategory_id.toString(),
    label: sc.subcategory_name,
  }));

  const priorityOptions = priorityData.map((p) => ({
    value: p.priority_id.toString(),
    label: p.priority_name,
  }));

  // const handleDispositionChange = async (selected: Option | null) => {
  //   const disposition = dispositionData.find(
  //     (d) => d.student_disposition_id === parseInt(selected?.value || "")
  //   );
  //   setSelectedDisposition(disposition || null);
  //   setNewTicket({
  //     ...newTicket,
  //     disposition: disposition?.student_disposition_id,
  //   });

  //   if (disposition) {
  //     const categoriesDataResponse = await fetchCategoriesData(
  //       disposition.student_disposition_id
  //     );
  //     setCategoriesData(categoriesDataResponse.results);
  //   }
  // };

  const handleCategoryChange = async (selected: Option | null) => {
    const category = categoriesData.find(
      (c) => c.category_id === parseInt(selected?.value || "")
    );
    setNewTicket({
      ...newTicket,
      category: category?.category_id,
      subcategory: null,
    });
    setSelectedCategory(
      category
        ? {
            value: category.category_id.toString(),
            label: category.category_name,
          }
        : null
    );
    setSelectedSubCategory(null);

    if (category && [2, 3].includes(category.category_id)) {
      setShowCallBackTime(true);
    } else {
      setShowCallBackTime(false);
    }

    if (category) {
      const subCategoryDataResponse = await fetchSubCategoryData(
        category.category_id
      );
      setSubCategoryData(subCategoryDataResponse.results);
    }
    setSelectedSubCategory(null);
  };

  const handleSubCategoryChange = (selected: Option | null) => {
    const subCategory = subCategoryData.find(
      (sc) => sc.subcategory_id === parseInt(selected?.value || "")
    );
    setSelectedSubCategory(
      subCategory
        ? {
            value: subCategory.subcategory_id.toString(),
            label: subCategory.subcategory_name,
          }
        : null
    );
    setNewTicket({
      ...newTicket,
      subcategory: subCategory?.subcategory_id,
    });
  };

  const handlePriorityChange = (selected: Option | null) => {
    const priority = priorityData.find(
      (p) => p.priority_id === parseInt(selected?.value || "")
    );
    setSelectedPriority(
      priority
        ? {
            value: priority.priority_id.toString(),
            label: priority.priority_name,
          }
        : null
    );
    setNewTicket({
      ...newTicket,
      priority: priority?.priority_id,
    });
  };

  const fetchData1 = async (id: number) => {
    try {
      const response = await fetch(
        `${webApi}/scripting/manage_scripts/${id}/`,
        options
      );
      const result = await response.json();
      if (result.data && result.data.script_file) {
        setPdfSrc(result.data.script_file);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchPdf = async () => {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
          Authorization: `Bearer ${jwtToken}`,
        },
      };

      try {
        const response = await fetch(pdfSrc, options);
        if (response.ok) {
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
        } else {
          console.error("Failed to fetch PDF");
        }
      } catch (error) {
        console.error("Error fetching PDF:", error);
      }
    };

    fetchPdf();
  }, [pdfSrc, jwtToken]);

  const handleSelectChange = (event: { target: { value: any } }) => {
    const scriptId = event.target.value;
    setSelectedScript(scriptId);
    fetchData1(scriptId);
  };

  const toggleCard = () => {
    setShowCard(!showCard);
    setShowForm(!showForm)
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const ringingAnimation = `
@keyframes ringing {
  0% { transform: translateY(0); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(2px); }
  75% { transform: translateY(-2px); }
  100% { transform: translateY(0); }
}
`;

  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(ringingAnimation, styleSheet.cssRules.length);

  const iconStyles = {
    chatScript: {
      fontSize: "24px",
      color: "blue",
      cursor: "pointer",
      marginBottom: "10px",
    },
    leaderboard: {
      fontSize: "24px",
      color: "green",
      cursor: "pointer",
      marginBottom: "10px",
    },
    chat: {
      fontSize: "24px",
      color: "red",
      cursor: "pointer",
      marginBottom: "10px",
    },
  };

  const containerStyle = {
    position: "fixed" as "fixed",
    bottom: "10px",
    right: "10px",
    display: "flex",
    flexDirection: "column" as "column",
    gap: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: Add background for better visibility
    borderRadius: "8px", // Optional: Rounded corners
    padding: "10px", // Optional: Add some padding
  };
  const [showForm, setShowForm] = useState(true);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SummerCamp Add Ticket</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SummerCampCallBacks}>Call Back</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Ticket</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Non-editable Fields Card */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                height: "100vh",
                paddingTop: "20px",
              }}
            >
              <Spin /> {/* Display loader while loading */}
            </div>
          ) : (
            <div>
              <div
                className="card"
                style={{
                  width: "25%",
                  margin: "10px",
                  float: "left",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  // backgroundColor: "#f3f4f6",
                  border: "1px solid #d1d5db",
                }}
              >
                <div className="card-body">
                  <h5
                    className="card-title"
                    style={{ fontWeight: "bold", marginBottom: "15px" }}
                  >
                    Student Details
                  </h5>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      SCS Number:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.SCS_Number}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Student:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Gender:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.gender_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Admission Status:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.admission_status_name}
                    </span>
                  </div>
                  {/* <div
                className="detail-row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <span
                  className="detail-key"
                  style={{ fontWeight: "bold", color: "#4b5563" }}
                >
                  State:
                </span>
                <span
                  className="detail-value"
                  style={{ textAlign: "right", color: "#1f2937" }}
                >
                  {newAdmin.state_name}
                </span>
              </div>
              <div
                className="detail-row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <span
                  className="detail-key"
                  style={{ fontWeight: "bold", color: "#4b5563" }}
                >
                  Zone:
                </span>
                <span
                  className="detail-value"
                  style={{ textAlign: "right", color: "#1f2937" }}
                >
                  {newAdmin.zone_name}
                </span>
              </div> */}
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Branch:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.branch_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Orientation:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.orientation_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Class:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.student_class_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Section:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.section_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Agent:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.agent_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      Academic Year:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.academic_year_name}
                    </span>
                  </div>
                  <div
                    className="detail-row"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px 0",
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <span
                      className="detail-key"
                      style={{ fontWeight: "bold", color: "#4b5563" }}
                    >
                      No. of Updates:
                    </span>
                    <span
                      className="detail-value"
                      style={{ textAlign: "right", color: "#1f2937" }}
                    >
                      {newAdmin.no_of_attempts}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div
            className="row justify-content-center"
            style={{
              marginTop: "20px",
              marginBottom: "15px",
              marginLeft: "5px",
            }}
          >
            <div className="col-sm-12 d-flex justify-content-between">
              <div>
                <button
                  className="btn btn-success me-2"
                  style={{ backgroundColor: "#28a745", color: "white" }}
                  onClick={handleCallClick}
                  disabled={isLoading}
                >
                  {callLoading ? (
                    <i className="spinner-border spinner-border-sm"></i>
                  ) : (
                    <>
                      <i className="ti ti-phone"></i> Call
                    </>
                  )}
                </button>
                <button
                  className="btn btn-success me-2"
                  style={{ backgroundColor: "#25D366", color: "white" }}
                >
                  <i className="ti ti-brand-whatsapp"></i> WhatsApp
                </button>
                <button
                  className="btn btn-success"
                  style={{ backgroundColor: "#007bff", color: "white" }}
                >
                  <i className="ti ti-message"></i> TextMessage
                </button>
              </div>
            </div>
          </div>

          {/* Editable Form */}
          {showForm &&(<div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
             <div
                className="card"
                style={{
                  width: "100%",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  padding: "20px",
                  backgroundColor: "#fff",
                  border: "1px solid #d1d5db",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className="modal-body light-violet-bg d-flex"
                      style={{ flexWrap: "wrap" }}
                    >
                      {/* <div
                        className="mb-3 me-3"
                        style={{
                          flex: "1 1 100%",
                          maxWidth: "300px",
                          marginRight: "15px",
                          width: "300px",
                        }}
                      >
                        <label className="form-label">Disposition</label>
                        <CommonSelect
                          className="select"
                          options={dispositionOptions}
                          onChange={handleDispositionChange}
                        />
                      </div> */}
                      <div
                        className="mb-3 me-3"
                        style={{
                          flex: "1 1 100%",
                          maxWidth: "300px",
                          marginRight: "15px",
                          width: "300px",
                        }}
                      >
                        <label className="form-label">Category</label>
                        <CommonSelect
                          className="select"
                          options={categoryOptions}
                          onChange={handleCategoryChange}
                          value={selectedCategory}
                        />
                      </div>
                      {showCallBackTime && (
                        <div
                          className="form-group mb-3"
                          style={{
                            width: "300px",
                            maxWidth: "300px",
                            marginRight: "15px",
                            position: "relative",
                          }}
                        >
                          <label className="form-label">Call Back Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            name="callbacktime"
                            placeholder="Call Back Time"
                            onChange={handleInputChange}
                            value={newTicket.callbacktime || ""}
                            required
                            onFocus={() => {
                              const doneText =
                                document.getElementById("doneText");
                              if (doneText) doneText.style.display = "inline";
                            }}
                            onBlur={() => {
                              const doneText =
                                document.getElementById("doneText");
                              if (doneText) doneText.style.display = "none";
                            }}
                          />
                          <small
                            id="doneText"
                            className="text-primary"
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              right: "10px", // Adjust this value to position it next to the calendar icon
                              top: "5px", // Adjust this value to align vertically
                              display: "none",
                            }}
                            onClick={() => {
                              const inputElement =
                                document.querySelector<HTMLInputElement>(
                                  'input[name="callbacktime"]'
                                );
                              if (inputElement) inputElement.blur();
                            }}
                          >
                            Done
                          </small>
                        </div>
                      )}

                      <div
                        className="mb-3"
                        style={{
                          flex: "1 1 100%",
                          maxWidth: "300px",
                          marginRight: "15px",
                          width: "300px",
                        }}
                      >
                        <label className="form-label">Sub-Category</label>
                        <CommonSelect
                          className="select"
                          options={subCategoryOptions}
                          onChange={handleSubCategoryChange}
                          value={selectedSubCategory}
                        />
                      </div>
                      <div
                        className="mb-3 me-3"
                        style={{
                          flex: "1 1 100%",
                          maxWidth: "300px",
                          marginRight: "15px",
                          width: "300px",
                        }}
                      >
                        <label className="form-label">Priority</label>
                        <CommonSelect
                          className="select"
                          options={priorityOptions}
                          onChange={handlePriorityChange}
                          value={selectedPriority}
                        />
                      </div>
                      <div
                        className="form-group mb-3"
                        style={{ flex: "1 1 100%", minWidth: "200px" }}
                      >
                        <label className="form-label">Description</label>
                        <textarea
                          className="form-control"
                          name="description"
                          placeholder="Description"
                          onChange={handleInputChange}
                          value={newTicket.description || ""}
                          rows={4} // Make sure to use number directly
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        to={routes.SummerCampCallBacks}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading1 ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          )}
          {showCard && (
            <div className="row justify-content-center">
              <div className="col-md-12 d-flex justify-content-center">
                <div
                  className="card"
                  style={{
                    width: "100%",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    // padding: "20px",
                    backgroundColor: "#fff",
                    border: "1px solid #d1d5db",
                  }}
                >
                  <div className="card-body">
                    <select
                      value={selectedScript}
                      onChange={handleSelectChange}
                      style={{marginBottom:"5px"}}
                    >
                      <option value="">Select a script</option>
                      {scriptDropdown.map((item) => (
                        <option key={item.script_id} value={item.script_id}>
                          {item.script_name}
                        </option>
                      ))}
                    </select>
                    {pdfUrl && (
                      <div>
                        <embed
                          src={pdfUrl}
                          type="application/pdf"
                          width="100%"
                          height="1100px"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {isCalling && (
            <div
              style={{
                position: "fixed",
                top: "10px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "5px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                fontSize: "1.2em",
                animation: "ringing 1s infinite",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                }}
              >
                <i
                  className="ti ti-phone"
                  style={{
                    fontSize: "1.5em",
                    color: "green",
                    marginRight: "5px",
                    animation: "ringing 1s infinite",
                  }}
                ></i>
                <span
                  style={{
                    animation: "ringing 1s infinite",
                  }}
                >
                  Calling to {newAdmin.name}
                </span>
              </div>
              {/* <button
      className="btn btn-danger"
      style={{ backgroundColor: "#dc3545", color: "white" }}
      onClick={handleEndCallClick}
    >
      <i
        className="ti ti-phone-off"
        style={{ fontSize: "1.5em" }}
      ></i>{" "}
      End Call
    </button> */}
            </div>
          )}
          <div style={containerStyle}>
            <img
               src="https://cdn-icons-png.freepik.com/256/14955/14955846.png?ga=GA1.1.568823308.1733236272&semt=ais_hybrid"
              alt="Chat Script"
              title="Chat Script"
              style={{ width: '50px', height: '50px', cursor: 'pointer', marginBottom: '10px' }}
              onClick={toggleCard}
            />
            {/* <FontAwesomeIcon
              icon={faTrophy as IconProp}
              title="Leaderboard"
              style={iconStyles.leaderboard}
            />
            <FontAwesomeIcon
              icon={faComments as IconProp}
              title="Chat"
              style={iconStyles.chat}
            /> */}
          </div>

          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>

          {/* /Row */}
        </div>
      </div>
    </div>
  );

  function formatKey(key: string) {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  }
};

export default AddSummerCampCallBackTicket;
